import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AxiosApiClient from '../utils/AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';

import swal from 'sweetalert';

import home_icon from '../../assets/frontend/images/home_icon.png';
import search_icon from '../../assets/frontend/images/search_icon.png';
import donate_icon from '../../assets/frontend/images/donate_icon.png';
import plus_icon from '../../assets/frontend/images/plus_icon_black.png';
import account_icon from '../../assets/frontend/images/account_icon.png';

const StickyBottomMemberNav = () => {

	//logout should be its own component
	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = useState(false);

	const LogoutService = (event) => {
		event.preventDefault();

		setIsLoading(true);

		const fetchApiData = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('get', '/api/logout', null, {});

				setApiData(response, "LogoutService");
			} catch (error) {
				handleApiError(error, "LogoutService");
			}
		};

		fetchApiData();
	}
	function setApiData(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();

				//redirect to home page
				navHistory('/');

			} else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();

				swal("Warning", response.data.message, "warning");

				navHistory('/login');

			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiError(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		//user not authenticated on server so remove from local storage
		AuthUtility.clearAuthData();
		setIsLoading(false);
		swal("Error", error, "error");
		navHistory('/login');
	}

	return (

		<div className="panel large mt-5">

			<div className="horizontal-container justify-center bt1-555 pt-5">
				<div className="mlr-30l-20m-5s">
					<Link to="member/home" className="button icon-sticky-bottom image-container no-underline">
						<div className="hide-for-small-only">
							<img src={home_icon} alt="home_icon" width="24" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Home</div>
						</div>
						<div className="show-for-small-only">
							<img src={home_icon} alt="home_icon" width="20" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Home</div>
						</div>
					</Link>
				</div>
				<div className="mlr-30l-20m-5s">
					<Link to="member/search" className="button icon-sticky-bottom image-container no-underline">
						<div className="hide-for-small-only">
							<img src={search_icon} alt="search_icon" width="24" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Search</div>
						</div>
						<div className="show-for-small-only">
							<img src={search_icon} alt="search_icon" width="20" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Search</div>
						</div>
					</Link>
				</div>
				<div className="mlr-30l-20m-5s">
					<Link to="/member/donate" className="button icon-sticky-bottom image-container no-underline">
						<div className="hide-for-small-only">
							<img src={donate_icon} alt="donate_icon" width="24" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Donate</div>
						</div>
						<div className="show-for-small-only">
							<img src={donate_icon} alt="donate_icon" width="20" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Donate</div>
						</div>
					</Link>
				</div>
				<div className=" mlr-30l-20m-5s">
					<Link to="/member/create" className="button icon-sticky-bottom image-container no-underline">
						<div className="hide-for-small-only">
							<img src={plus_icon} alt="plus_icon" width="24" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Create</div>
						</div>
						<div className="show-for-small-only">
							<img src={plus_icon} alt="plus_icon" width="20" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Create</div>
						</div>
					</Link>
				</div>
				<div className="mlr-30l-20m-5s">
					<Link to="/member/account" className="button icon-sticky-bottom image-container no-underline">
						<div className="hide-for-small-only">
							<img src={account_icon} alt="account_icon" width="24" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Account</div>
						</div>
						<div className="show-for-small-only">
							<img src={account_icon} alt="account_icon" width="20" className="pb-3" />
							<div className="font-source-sans font-size-12 font-weight-600 letter-spacing-0px uppercase">Account</div>
						</div>
					</Link>
				</div>
			</div>

		</div>

	);
}

export default StickyBottomMemberNav;